import './Manager.scss';
import ManagerNav from './ManagerNav';

export default function Manager(props) {
  return (
    <section className="manager-screen">
      <ManagerNav></ManagerNav>
    </section>
  );
}
